import { CircularProgress } from '@mui/material';
import {
  Box,
  FirstPageIcon,
  IconButton,
  LastPageIcon,
  NextPageIcon,
  PreviousPageIcon,
  Stack,
  Typography,
  useTheme,
} from '@silverstein-properties/inspirelabs-ui';

type CustomPaginationPropsType = {
  show: boolean;
  currentPage: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
};

export function CustomPagination(props: CustomPaginationPropsType) {
  const { show, currentPage, isLoading, pageSize, totalItems, onPageChange } =
    props;
  const theme = useTheme();

  const totalPages = Math.ceil(totalItems / pageSize);
  const canPreviousPage = currentPage > 0;
  const canNextPage = currentPage < totalPages - 1;

  const fromIndex = currentPage * pageSize + 1; // 0-based index
  const toIndex = Math.min((currentPage + 1) * pageSize, totalItems);

  const goToFirstPage = () => onPageChange(0);
  const goToPreviousPage = () => onPageChange(currentPage - 1);
  const goToNextPage = () => onPageChange(currentPage + 1);
  const goToLastPage = () => onPageChange(totalPages - 1);

  return show ? (
    <Stack
      direction="row"
      spacing={theme.spacers.xxl2}
      justifyContent="center"
      alignItems="center"
      marginTop={theme.spacers.l}
      marginBottom={theme.spacers.xxl}
    >
      <Box>
        <IconButton
          onClick={goToFirstPage}
          disabled={!canPreviousPage}
          color="primary"
        >
          <FirstPageIcon width={theme.constants.ICON_SIZE.small} />
        </IconButton>
        <IconButton
          onClick={goToPreviousPage}
          disabled={!canPreviousPage}
          color="primary"
        >
          <PreviousPageIcon width={theme.constants.ICON_SIZE.small} />
        </IconButton>
      </Box>

      {isLoading ? (
        <CircularProgress
          size={theme.constants.ICON_SIZE.small}
          color="inherit"
        />
      ) : (
        <Typography variant="body3" color="primary.medium">
          {fromIndex}-{toIndex} of {totalItems}
        </Typography>
      )}

      <Box>
        <IconButton
          onClick={goToNextPage}
          disabled={!canNextPage}
          color="primary"
        >
          <NextPageIcon width={theme.constants.ICON_SIZE.small} />
        </IconButton>
        <IconButton
          onClick={goToLastPage}
          disabled={!canNextPage}
          color="primary"
        >
          <LastPageIcon width={theme.constants.ICON_SIZE.small} />
        </IconButton>
      </Box>
    </Stack>
  ) : null;
}
